module.exports = __webpack_public_path__ + "img/Tutorial_LoadDatasource.70d538dd.png";